(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:EventManagerService
     *
     * @description
     *
     */
    angular
        .module('commons')
        .service('EventManagerService', EventManagerService);

    function EventManagerService() {
        var self = this,
            eventMap = {};

        self.EVENT = {
            USER_LOGGED_IN: 'event.user_logged_in',
            USER_LOGGED_OUT: 'event.user_logged_out',
            DO_LOGGED_OUT: 'event.do_logged_out',
            TAB_REMOVED: 'event.tab_removed',
            TAB_OPEN: 'event.tab_open',
            TAB_SELECTED: 'event.tab.selected',
            SHOW_HIDE_LOADING: 'event.show_hide_loading',
            DO_ELASTIC_SEARCH: 'event.do_elastic_search',
            DATEPICKER_OPTIONS_CHANGED: 'datepicker_options_changed',
            SCROLL_TO_TOP: 'event.scroll_to_top',
            SCROLL_TO_LEFT : 'event.scroll_to_left',
            SCROLL_TO_POINT: 'event.scroll_to_point',
            COLLAPSE_ALL_EXPAND_ROWS: 'event.collapse_all_row_expands',
            SCREEN_SIZE_CHANGE: 'event.screen_size_change',
            RESET_SCROLL_TOP: 'event.reset_scroll_top',
            MULTI_SELECT_VALUE_CHANGE: 'event.multi.select.value.change',
            DO_REFRESH:'event.do_refresh',
            PANEL_CLOSE:'event.panel_close',
            TRAINING_FLIGHT_UPDATE: 'event.training_flight_update',
            NEW_ALERT_COUNT: 'event.new_alert_count'
        };

        self.EVENT.SCROLL = {
            SCROLL_LEFT_CHANGE : 'event.scroll.scfoll_left_change',
            SCROLL_TOP_CHANGE : 'event.scroll.scfoll_top_change'
        };

        self.EVENT.SPACEBAR = {
                SAVE_ROTATION: 'event.flight_watch.save_rotation',
                CLICK_NEW_CHECK: 'event.flight_watch.add_newCheck',
                RELOAD_ROTATION: 'event.flight_watch.reload_rotation',
                RUN_NEW_ROTATION: 'event.flight_watch.run_new_rotation',
                CONFIG_AUTO_ROTATION: 'event.flight_watch.config_auto_rotation',
                SET_SEARCH_PARAM : 'event.flight_watch.set_search_param'
            };

        self.EVENT.TOOLBAR = {
            VIEW_MODE_CHANGE: 'event.toolbar.view_mode_change',
            FULL_SCREEN: 'event.toolbar.full_screen',
            CREATE: 'event.toolbar.create',
            REFRESH: 'event.toolbar.refresh',
            PUBLISH: 'event.toolbar.publish',
            CONFIG_CHANGED: 'config_changed',
            CHANGE_REFRESH_TIME: 'event.flight_watch.page_refresh',
            SCREEN_MODE_CHANGE: 'event.toolbar.screen_mode_change',
            CLICK_CREATE_PROFILE:'event.toolbar.click_create_profile',
            SEND_ROT_CNG_EMAIL :'event.toolbar.click_send_email_for_rotation_change',
            SEND_ROT_EMAIL:'event.toolbar.click_send_email_for_rotation',
            SHOW_ROTATION_SUMMARY : 'event.flight_watch.show_rotation_summary',
            SHOW_SLOT_SEARCH : 'event.flight_watch.show_slot_search'
        };

        self.EVENT.TOOLBAR.CREWING = {
            ASSIGN_PAIRING: 'event.toolbar.crewing.assign_pairing',
            ASSIGN_EVENT: 'event.toolbar.crewing.assign_event',
            ASSIGN_TRAINING: 'event.toolbar.crewing.assign_training',
            EDIT_BLOCK: 'event.toolbar.crewing.edit_block',
            DELETE_BLOCK: 'event.toolbar.crewing.delete_block',
            ADD_MEMO: 'event.toolbar.crewing.add_memo',
            SMS: 'event.toolbar.crewing.sms',
            ALERT: 'event.toolbar.crewing.alert',
            REGULATION_DETAILS: 'event.toolbar.crewing.regulation_details',
            HISTORY: 'event.toolbar.crewing.history',
            SHOW_ALL_CREW_SCHEDULE: 'event.toolbar.crewing.show_all_crew_schedule',
            EMAIL_CREW: 'event.toolbar.crewing.email_crew',
            UPDATE_SCHEDULE_FOR_CREWS: 'event.crewing.update_schedule_for_crews',
            EDIT_PAIRING: 'event.toolbar.crewing.edit_pairing',
            SHOW_IN_PORTAL: 'event.toolbar.crewing.show_in_crew_portal',
            UNDO: 'event.toolbar.crewing.undo',
            MESSAGEMANAGER: 'event.toolbar.crewing.messageManager',
            SMS_MANAGER: 'event.toolbar.crewing.manager',
            EVALUATE_TRAININGS: 'event.toolbar.crewing.evaluate_trainings'
        };

        self.EVENT.TOOLBAR.TRACKING = {
            FILTER_BY_CREW_COMPOSITION_ERROR : 'event.toolbar.tracking.filter_by_crew_composition',
            FILTER_BY_EXPIRIES_ERROR : 'event.toolbar.tracking.filter_by_expiries',
            FILTER_BY_FDP_RULE_ERROR : 'event.toolbar.tracking.filter_by_fdp_rule',
            FILTER_BY_CURRENT_DUTY : 'event.toolbar.tracking.filter_by_current_duty',
            FILTER_BY_NEXT_DUTY : 'event.toolbar.tracking.filter_by_next_duty',
            FILTER_BY_LANGUAGE_ERROR : 'event.toolbar.tracking.filter_by_language',
            FILTER_BY_GENDER_ERROR : 'event.toolbar.tracking.filter_by_gender',
            FILTER_BY_TRAINEES : 'event.toolbar.tracking.filter_by_trainees'
        };


        self.EVENT.CONTEXT_MENU = {
            ADD_MEMO: 'event.context_menu.add_memo',
            ALERT: 'event.context_menu.alert',
            ASSIGN_EVENT: 'event.context_menu.assign_event',
            ASSIGN_PAIRING: 'event.context_menu.assign_pairing',
            REPLACE_PARING: 'event.context_menu.replace_pairing',
            ASSIGN_TRAINING: 'event.context_menu.assign_training',
            ASSIGN_OFF: 'event.context_menu.assign_off',
            ASSIGN_EVENT_OFC: 'event.context_menu.assign_event_ofc',
            ASSIGN_SICK_LEAVE: 'event.context_menu.assign_sick_leave',
            ASSIGN_ANNUAL_LEAVE: 'event.context_menu.assign_annual_leave',
            ASSIGN_VOLUNTARILY_UNPAID_LEAVE: 'event.context_menu.assign_voluntarily_unpaid_leave',
            ASSIGN_UNPAID_LEAVE: 'event.context_menu.assign_unpaid_leave',
            ASSIGN_EMERGENCY_LEAVE: 'event.context_menu.assign_emergency_leave',
            ASSIGN_IND_LEAVE: 'event.context_menu.assign_ind_leave',
            ASSIGN_HAJJ_LEAVE: 'event.context_menu.assign_hajj_leave',
            ASSIGN_COMPASSIONATE_LEAVE: 'event.context_menu.assign_compassionate_leave',
            ASSIGN_MATERNITY_LEAVE: 'event.context_menu.assign_maternity_leave',
            ASSIGN_PATERNITY_LEAVE: 'event.context_menu.assign_paternity_leave',
            ASSIGN_SUSPENSION_LEAVE: 'event.context_menu.assign_suspension_leave',
            ASSIGN_NOSHOW_LEAVE: 'event.context_menu.assign_noshow_leave',
            ASSIGN_MARRIAGE_LEAVE: 'event.context_menu.assign_marriage_leave',
            ASSIGN_UNPAID_SICK_LEAVE: 'event.context_menu.assign_unpaidsick_leave',
            ASSIGN_ABSENT_LEAVE: 'event.context_menu.assign_absent_leave',
            ASSIGN_COMMUTING_LEAVE: 'event.context_menu.assign_commuting_leave',
            ASSIGN_SPECIAL_UNPAID_LEAVE: 'event.context_menu.assign_specialunpaid_leave',
            ASSIGN_FM_LEAVE: 'event.context_menu.assign_fm_leave',
            ASSIGN_FLEXIBLE_SICK_LEAVE: 'event.context_menu.assign_flexiblesick_leave',
            ASSIGN_SNY_LEAVE: 'event.context_menu.assign_sny_leave',
            ASSIGN_AWB_LEAVE: 'event.context_menu.assign_awb_leave',
            ASSIGN_WFD_LEAVE: 'event.context_menu.assign_wfd_leave',
            ASSIGN_LIM_LEAVE: 'event.context_menu.assign_lim_leave',
            ASSIGN_VUNP_LEAVE: 'event.context_menu.assign_vunp_leave',
            ASSIGN_SBD_LEAVE: 'event.context_menu.assign_sbd_leave',
            ASSIGN_BLOCK_DAYS: 'event.context_menu.assign_block_days',
            ASSIGN_CREW_TO_TRAINING : 'event.context_menu.assign_crew_to_training',
            CREW_INFORMATION: 'event.context_menu.crew_information',
            CREW_SCHEDULE: 'event.context_menu.crew_schedule',
            COPY_DUTY: 'event.context_menu.copy_duty',
            CANCEL_COPY_OPERATION: 'event.context_menu.cancel_copy_operation',
            COPY_MULTIPLE_DUTY: 'event.context_menu.copy_multiple_duty',
            CUT_BLOCK: 'event.context_menu.cut_block',
            CANCEL_CUT_OPERATION: 'event.context_menu.cancel_cut_operation',
            PAST_BLOCK: 'event.context_menu.past_block',
            DELETE_DUTY: 'event.context_menu.delete_duty',
            EDIT_BLOCK: 'event.context_menu.edit_block',
            EDIT_EVENT: 'event.context_menu.edit_event',
            EDIT_PAIRING: 'event.context_menu.edit_pairing',
            EMAIL_CREW: 'event.context_menu.email',
            HISTORY: 'event.context_menu.history',
            OPEN_CREW_TRACKING : 'event.context_menu.open_crew_tracking',
            REGULATION_DETAILS: 'event.context_menu.regulation_details',
            SMS: 'event.context_menu.sms',
            SEND_NOTIFICATION: 'event.context_menu.send_notification',
            SHOW_ALL_CREW_SCHEDULE: 'event.context_menu.show_all_crew_schedule',
            DESELECT_ALL: 'event.context_menu.deselect_all',
            SWAP: 'event.context_menu.swap',
            UPDATE_FLIGHT: 'event.context.flight_watch.update_flight',
            DELETE_FLIGHT: 'event.context.flight_watch.delete_flight',
            SEND_CREW_NOTIFICATION: 'event.context.flight_watch.send_crew_notification',
            ADD_OFF_TO: 'add.off.to',
            ADD_OFF_TO_NEXT_DAY: 'add.off.to.next.day',
            ADD_OFF_TO_PREVIOUS_DAY: 'add.off.to.previous.day',
            CONVERT_TO_DEADHEAD: 'convert.to.deadhead',
            CONVERT_TO_DEADHEAD_POSITIONING: 'convert.to.deadhead.positioning',
            SHOW_CREW_EXPIRY: 'event.context_menu.crew.show_crew_expiry',
            EDIT_CHECK: 'event.context.flight_watch.edit_check',
            CREW_MOVE_TO_TOP: 'event.context.crewing.crew_move_to_top',
            DELETE_BLOCK: 'event.context.crewing.delete_block',
            SHOW_CREW_FILTER : 'event.context.show_crew_filter',
            SHOW_IN_CREW_PORTAL : 'event.context.show_in_crew_portal',
            HIDE_IN_CREW_PORTAL : 'event.context.hide_in_crew_portal',
            SHOW_VIOLATIONS: 'event.context.show_violation_reasons',
            PAX_MSG_DETAILS: 'event.context_menu.pax_msg_details',
            SELECT_ALL: 'event.context_menu.select_all',
            DELETE_CHECK: 'event.context.flight_watch.delete_check',
            UPDATE_DELETE_CHECK_LIST: 'event.context.flight_watch.update_delete_check_list',
            SHOW_LOG: 'event.context.flight_watch.show_log',
            BIDDING_DELETE_ALL: 'event.context.bidding.delete.all',
            BIDDING_APPROVE_ALL: 'event.context.bidding.approve.all',
            BIDDING_APPROVE_EVENT: 'event.context.bidding.approve.event',
            BIDDING_APPROVE_PATTERN: 'event.context.bidding.approve.pattern',
            ASSIGN_CNT: 'event.context_menu.assign_cnt',
            ASSIGN_LEAVE: 'event.context_menu.assign_leave',
            EVALUATE_TRAININGS: 'event.context_menu.evaluate_trainings',
            ACCEPT_DUTY: 'event.context_menu.accept_duty',
            ACKNOWLEDGE_DUTY: 'event.context_menu.acknowledge_duty',
            CONVERT_TO_SICK: 'event.context_menu.convert_to_sick',
            SBY_CALL_OUT: 'event.context_menu.call_out_time',
            ASSIGN_SECONDEDIN_OTHER_HUBS: 'event.context_menu.assign_secondedin_other_hubs',
            ASSIGN_AVAILABLE: 'event.context_menu.assign_available',
            ASSIGN_TO_BE_NOTIFIED: 'event.context_menu.assign_to_be_notified',
            ASSIGN_CABIN_SPECIAL_DUTY: 'event.context_menu.assign_cabin_special_duty',
            ASSIGN_CABIN_SUPPORT_ACTIVITY: 'event.context_menu.assign_cabin_support_activity',
            DELAYED_REPORT_TIMING: 'event.context_menu.delayed_report_timing',
            IGNORE_REGULATION_VIOLATION: 'event.context_menu.ignore_regulation_violation',
            REVERT_IGNORED_REGULATION_VIOLATION: 'event.context_menu.revert_ignored_regulation_violation'
        };

        self.EVENT.PANEL = {
            DATA_CHANGED: 'event.panel.data_changed',
            RELOAD_PANEL_DATA: 'event.panel.data.reload'
        };

        self.EVENT.CREWING = {
            SCHEDULE_UPDATED: 'event.crewing.schedule_updated',
            INDIVIDUAL_RECORD_UPDATED: 'event.crewing.individual_record_updated',
            IS_CREW_SCHEDULE_PUBLISHED: 'event.crewing.is_crew_schedule_published',
            OPEN_MEMO: 'event.crewing.open_memo',
            RESET_SELECTED_CREW_AND_DAYS: 'event.crewing.reset_selected_crew_and_days',
            LAST_RECORD_REACHED: 'event.crewing.last_record_reached',
            CREW_LIST_UPDATED : 'event.crewing.crew_list_loaded',
            CREW_IDS_CHANGED : 'event.crewing.change_crew_ids'
        };

        self.EVENT.TRACKING = {
            TRACKING_FLIGTS_UPDATED : 'event.tracking.tracking_flights_updated',
            PAIRING_FOR_SELECTED_FLIGHT_UPDATED : 'event.tracking.pairing_for_selected_flight_updated',
            GET_PAIRING_FOR_SELECTED_FLIGHT : 'event.tracking.get_pairing_for_selected_flight',
            FLIGHT_REG_FILTER_DEACTIVATED : 'event.tracking.flight_reg_filter_deactivated',
            FLIGHT_REG_FILTER_ACTIVATED : 'event.tracking.flight_reg_filter_activated'
        };

        self.EVENT.CREATE_PAIRING = {
            UPDATE_PAIRING: 'event.create_pairing.update_pairing',
            VIEW_CHANGE: 'view_change',
            FLIGHT_DATA_CHANGE: 'flight_data_change',
            TRAINING_DATA_CHANGE: 'training_data_change',
            VIEWPORT_DATA_CHANGE: 'viewport_data_change',
            UPDATE_LANGUAGE_LIST: 'update_language_list',
            PAIRING_COMPLIMENTS: 'pairing_compliments',
            CREATE_PAIRING_SUCCESS: 'create_pairing_success',
            APPEND_FLIGHT_DATA: 'append_flight_data',
            EDIT_PAIRING_SUCCESS : 'edit_pairing_success',
            FDP_FAILED_CHANGE_BASE : 'change_base_when_fdp_failed'
        };
        self.EVENT.UPDATE_FLIGHT_DETAILS = {
            CANCEL_FLIGHT: 'event.flight_watch.cancel_flight',
            UPDATE_FLIGHT: 'event.flight_watch.update_flight',
            UPDATE_ROTATION : 'event.flight_watch.update_rotation'
        };

        self.EVENT.MANAGE_PAIRING = {
            DATA_CHANGE: 'data_change',
            APPEND_PAIRING_DATA: "append_pairing_data",
            UPDATE_PAIRING_DATA: "update_pairing_data",
            GENERATE_PAIRING: "manage_pairing",
            ADD_PAIRING: "add_pairing",
            COPY_PAIRING: "copy_pairing",
            DISCREPANCY_PAIRING: "discrepancy_pairing",
            AUTO_PAIRING: "auto_pairing"
        };

        self.EVENT.CREW_SCHEDULE = {
            TYPE_CHANGE: 'event.crew_schedule.type_changed',
            UNDO: 'event.toolbar.crew_schedule.undo'
        };

        self.EVENT.TRAINING_PROGRAME = {
            VIEW_CHANGED: 'event.training.programs.view.changed',
            DATA_CHANGED: 'event.training.programs.data.changed',
            GOTO_NEXT_PREVIOUS: 'event.training.programs.next.previous',
            ADD_NEW_TRAINING: 'event.training.program.add.new.training',
            ADD_TRAINING_COMP:'event.training.program.add.new.training.component'
        };

        self.EVENT.TRAINING_ASSIGN_CREW = {
            ALL_CREW_TYPES_CHANGED : 'event.training.program.assign_crew.crew_types_changes',
            ALL_CREW_LIST_CHANGED : 'event.training.program.assign_crew.all_crew_list_changed',
            DISCREPANCY_TRAINING_ASSIGN_SUCCESS: 'event.discrepancy.training.assign.success',
            ON_CLOSE_EXTERNAL_CREW_POPUP:'close_external_crew_popup'
        };

        self.EVENT.CREW_PROFILE = {
            EDIT_FAIL: 'event.crew_profile.edit_fail',
            PAYMENT_EDIT_STATE_CHANGE : 'payment.edit.state.change'
        };

        self.EVENT.DOCUMENT_MANAGER = {
            FILL_CREW_BY_TYPE: 'event.fill.crew_by_type'
        };

        self.EVENT.RENEWALS = {
            ASSIGN_TRAINING:'event.renewals.assign_trainings'
        };

        self.EVENT.FLIGHT_REPORT = {
        		CABIN_FLIGHT_RPT_EDIT:'event.flight.report.update'
        };

        self.EVENT.TOOLBAR.FLIGHTPUNCTUALITY = {
        		DELAY_CODES: 'event.toolbar.flightpunctuality.delay_codes',
            CREW_DETAILS: 'event.toolbar.flightpunctuality.crew_details',
            SEND_LIDO: 'event.toolbar.flightpunctuality.send_lido',
            FLIGHT_LOG: 'event.toolbar.flightpunctuality.flight_log',
        		EDIT: 'event.toolbar.flightpunctuality.edit',
        		SMS: 'event.toolbar.flightpunctuality.sms',
        		LIDO: 'event.toolbar.flightpunctuality.lido'
        }

        self.EVENT.CREW_BIDDING = {
        	RESET_BOTTOM_LINE_OPENED_FLAG : 'event.reset.bottom.line.opened.flag',
        	SEARCH_BIDDING_INFO : 'event.search.information',
        	SEARCH_BIDDING_WITH_SEARCH_OPTIONS : 'event.search.bidding.information.by.search.options',
        	RESET_SEARCH_RESULT : 'event.reset.search.result',
        	RESET_SELECTED_CREW_BID : 'event.reset.selected.crew.bid',
        	CLEAR_BOTTOM_LINE : 'event.bottom.line.information',
        	DRAW_TIME_LINES : 'event.draw.bidding.time.lines',
        	DRAW_BIDDING_INFO : 'event.draw.bidding.informations',
        	REMOVE_SELECTED_BID : 'event.remove.selected.crew.bid',
        	APPROVE_SELECTED_BID : 'event.approve.selected.crew.bids',
        	CANCEL_APPROVE_PROCESS : 'event.cancel.bid.approve.process',
        	UPDATE_BOTTOM_LINE_DATA : 'event.update.bottom.line.information',
        	DRAW_BOTTOM_LINE : 'event.draw.bottom.line',
        	CLOSE_BOTTOM_LINE : 'event.close.bottom.line',
        	SAVE_MAX_CREW_BIDDING : 'event.save max crew bidding details'

        };

        self.EVENT.MISSIN_SIGN_IN = {
    		RELOAD_SIGN_IN_DATA:'event.reload.sign.in.data',
    		RELOAD_SIGN_OUT_DATA :'event.reload.sign.out.data'
        };

        self.EVENT.PAYMENT_RATES = {
    		DELETE_RANGE:'event.delete.range',
			APPLY_RANGE :'event.apply.range',
			SAVE_RANGE :'event.save.range'
            };

        self.EVENT.CREW_PAYMENT_RATES = {
        		DELETE_RANGE:'crew.event.delete.range',
    			APPLY_RANGE :'crew.event.apply.range',
    			SAVE_RANGE :'crew.event.save.range',
    			REFRESH_OTHER_PAYMENT : 'crew.event.refresh.other.rates'
       };

    	self.EVENT.TOOLBAR.CABIN_FLIGHT_ADMIN = {
    		ALL:'event.toolbar.cabin.crew.show.all',
    		MISSING:'event.toolbar.cabin.crew.show.missing',
    		PENDING:'event.toolbar.cabin.crew.show.pending',
    		APPROVED:'event.toolbar.cabin.crew.show.approved',
    		EXPORT:'event.toolbar.cabin.crew.export',
        MANUALLY_SUBMITTED:'event.toolbar.cabin.crew.show.manually.submitted'
    	};
    	self.EVENT.TOOLBAR.VOYAGE = {
        		ALL:'event.toolbar.voyage.show.all',
        		CLOSED:'event.toolbar.voyage.show.closed',
        		OPENED:'event.toolbar.voyage.show.opened',
        		MODEL_CLOSED :'event.toolbar.popup.model.closed'
        	};

    	self.EVENT.TOOLBAR.OTHER_HUB_HOURS = {
        		ADD:'event.toolbar.other.hub.hours.add',
        		IMPORT :'event.toolbar.other.hub.hours.import',
        		IMPORT_BY_OVERRIDING : 'event.toolbar.other.hub.hours.import.override',
        		CLEAR :'event.toolbar.other.hub.hours.clear',
        		SEARCH : 'event.toolbar.other.hub.hours.search',
        		DELETE_ALL : 'event.toolbar.other.hub.hours.delete.all'
        	};

    	self.EVENT.FLIGHT_WATCH = {
                SEARCH : 'event.flight.watch.search'
            };

    	self.EVENT.DUTY_SHEET = {
                REFRESH : 'event.dutySheet.refresh'
            };

        self.registerEventListener = function (eventType, eventListener, allowDuplicateListeners) {
            if (angular.isDefined(eventType) && angular.isDefined(eventListener)) {
                if (angular.isUndefined(eventMap[eventType])) {
                    eventMap[eventType] = [];
                }

                if (!!eventListener.name) {
                    if (!!allowDuplicateListeners) {
                        eventMap[eventType].push(eventListener);
                    } else{
                        var index = _.findIndex(eventMap[eventType],function(listener){return listener.name == eventListener.name});
                        if(index >= 0){
                            eventMap[eventType].splice(index,1,eventListener);
                        }else{
                            eventMap[eventType].push(eventListener);
                        }
                    }
                } else {
                    console.log('unnamed listener registered');
                    eventMap[eventType].push(eventListener);
                }
            } else {
                console.log('Event Type of Listener function missing');
            }
        };

        self.notifyEventListeners = function (eventType, data) {
            angular.forEach(eventMap[eventType], function (listener) {
                listener(data);
            });
        };

    }
}());
